import { JetView } from 'webix-jet';
import { devConfig, recapchaLogin } from '../config/config';

/**
 * Class representing the login view.
 * @extends JetView
 */
export default class loginView extends JetView {
    /**
     * Configures the login view layout and elements.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var codeReset = ''; // Variable to store reset code from URL
        var url = window.location.href.split('/'); // Split URL to analyze segments
        var flag = true; // Flag to determine if the restore email link should be visible

        // Check URL segments for reset-password and cashier-related paths
        url.forEach(function (obj) {
            if (obj == 'reset-password') {
                codeReset = url[url.length - 1]; // Store the last segment as reset code
            }
            if (obj.indexOf('caja') !== -1 || obj.indexOf('cashier') !== -1) {
                flag = false; // Set flag to false if cashier-related path is found
            }
        });

        // Define a custom UI component for reCAPTCHA
        webix.protoUI(
            {
                name: 'recapcha',
                $init: function () {
                    this.$ready.push(function () {
                        var key = this.config.sitekey; // Get site key from configuration
                        try {
                            if (window.grecaptcha != undefined) {
                                window.grecaptcha.render(this.$view, {
                                    sitekey: key, // Render reCAPTCHA with the site key
                                });
                            }
                        } catch (e) {
                            console.log(e); // Log any errors during rendering
                        }
                    });
                },
                getValue: function () {
                    try {
                        return this.$view.querySelector('textarea').value; // Get reCAPTCHA response value
                    } catch (e) {
                        console.log(e); // Log any errors during value retrieval
                    }
                },
                setValue: function () {
                    // Placeholder for setting value (not implemented)
                },
                focus: function () {
                    // Placeholder for focus behavior (not implemented)
                },
                defaults: {
                    name: 'g-recaptcha-response', // Default name for reCAPTCHA response
                    borderless: true,
                    height: 85,
                },
            },
            webix.ui.view,
        );

        // Define the first form for login
        const form1 = [
            {
                view: 'button',
                id: 'logo-login',
                css: 'logo-login',
                height: 60,
                align: 'center',
            },
            {
                view: 'label',
                label: 'Username',
                height: 20,
                css: 'login-username',
            },
            {
                view: 'text',
                placeholder: 'username',
                align: 'center',
                name: 'username',
                height: 38,
                marginY: 0,
            },
            {
                view: 'label',
                label: 'Password',
                height: 20,
                css: 'login-password',
            },
            {
                view: 'text',
                type: 'password',
                placeholder: 'password',
                height: 38,
                marginY: 0,
                align: 'center',
                name: 'password',
                id: 'passwordField',
                on: {
                    onAfterRender: function () {
                        var input = this.getInputNode();
                        if (!input) return;

                        var box = input.parentNode; // Normally .webix_inp_static
                        if (!box) return;

                        // Avoid duplicates if the view is re-rendered
                        if (box.querySelector('.password-eye')) return;

                        // Secure container positioned
                        if (box.style.position !== 'relative') box.style.position = 'relative';

                        // Create eye icon
                        var eye = document.createElement('span');
                        eye.className = 'webix_icon wxi-eye-slash password-eye';

                        // Local state (false = hidden)
                        var visible = false;
                        var self = this;

                        eye.onclick = function () {
                            var inp = self.getInputNode();
                            if (!inp) return;
                            visible = !visible;
                            // We change the type of the <input> directly (without define/refresh)
                            inp.setAttribute('type', visible ? 'text' : 'password');
                            eye.className = 'webix_icon ' + (visible ? 'wxi-eye' : 'wxi-eye-slash') + ' password-eye';
                        };

                        box.appendChild(eye);

                        // Padding so that the text does not collide with the icon
                        input.style.paddingRight = '40px';
                    },
                },
            },
            {
                view: 'label',
                label: _('Olvidó su contraseña?'), // Label for password recovery
                height: 20,
                css: 'restore-email',
                hidden: flag, // Hide if flag is true
                click: () => {
                    $$('formlog').hide(); // Hide login form
                    $$('formemail').show(); // Show email recovery form
                },
            },
            {
                view: 'recapcha', // Include reCAPTCHA in the form
                sitekey: '6LegdVspAAAAAJr8epripRpgX22Lc--94j2iNyij', // Site key for reCAPTCHA
                hidden: !devConfig.getRecapchaLogin(), // Hide based on configuration
            },
            {
                view: 'button',
                id: 'consultButton',
                css: 'button-login',
                label: 'Continue', // Label for continue button
                hotkey: 'enter', // Hotkey for the button
                align: 'center',
                height: 38,
                click: () => {
                    var items = $$('formlog').getValues(); // Get values from the login form
                    const superView = this; // Reference to the current view
                    var url2 = window.location.href.split('/'); // Split URL to analyze segments
                    var url = url2[4]; // Get the relevant segment for partner login
                    // Map partner names to corresponding IDs
                    if (url == 'virtualsoft') {
                        url = -1;
                    } else {
                        if (url == 'doradobet') {
                            url = 0;
                        } else {
                            if (url == 'justbet') {
                                url = 2;
                            } else {
                                if (url == 'ibetsupreme') {
                                    url = 1;
                                } else {
                                    if (url == 'miravalle') {
                                        url = 3;
                                    } else {
                                        if (url == 'casinopalace') {
                                            url = 4;
                                        } else {
                                            if (url == 'netabet') {
                                                url = 6;
                                            } else {
                                                if (url == 'intercontinental') {
                                                    url = 5;
                                                } else {
                                                    if (url == 'astonia') {
                                                        url = 7;
                                                    } else {
                                                        if (url == 'ecuabet') {
                                                            url = 8;
                                                        } else {
                                                            if (url == 'winbet') {
                                                                url = 9;
                                                            } else {
                                                                if (url == 'powerbet') {
                                                                    url = 12;
                                                                } else {
                                                                    if (url == 'tribet') {
                                                                        url = 13;
                                                                    } else {
                                                                        if (url == 'lotosports') {
                                                                            url = 14;
                                                                        } else {
                                                                            if (url == 'hondubet') {
                                                                                url = 15;
                                                                            } else {
                                                                                if (url == 'latinbet') {
                                                                                    url = 16;
                                                                                } else {
                                                                                    if (url == 'milbets') {
                                                                                        url = 17;
                                                                                    } else {
                                                                                        if (url == 'gangabet') {
                                                                                            url = 18;
                                                                                        } else {
                                                                                            if (
                                                                                                url == 'certdoradobet'
                                                                                            ) {
                                                                                                url = 10;
                                                                                            } else {
                                                                                                if (url == 'sivarbet') {
                                                                                                    url = 20;
                                                                                                } else {
                                                                                                    if (url == 'vsft') {
                                                                                                        url = 19;
                                                                                                    } else {
                                                                                                        if (
                                                                                                            url ==
                                                                                                            'camanbet'
                                                                                                        ) {
                                                                                                            url = 21;
                                                                                                        } else {
                                                                                                            if (
                                                                                                                url ==
                                                                                                                'ganamex'
                                                                                                            ) {
                                                                                                                url = 22;
                                                                                                            } else {
                                                                                                                if (
                                                                                                                    url ==
                                                                                                                    'paniplay'
                                                                                                                ) {
                                                                                                                    url = 23;
                                                                                                                } else {
                                                                                                                    if (
                                                                                                                        url ==
                                                                                                                        'redcasino'
                                                                                                                    ) {
                                                                                                                        url = 25;
                                                                                                                    } else {
                                                                                                                        if (
                                                                                                                            url ==
                                                                                                                            'ganaplay'
                                                                                                                        ) {
                                                                                                                            url = 27;
                                                                                                                        } else {
                                                                                                                            if (
                                                                                                                                url ==
                                                                                                                                'slotdunyasi'
                                                                                                                            ) {
                                                                                                                                url = 28;
                                                                                                                            } else {
                                                                                                                                if (
                                                                                                                                    url ==
                                                                                                                                    'rapidplay'
                                                                                                                                ) {
                                                                                                                                    url = 29;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // Validate username and password fields
                    if (items.username !== '' && items.password !== '') {
                        // Check reCAPTCHA response if enabled
                        if (
                            (devConfig.getRecapchaLogin() && items['g-recaptcha-response'] !== '') ||
                            !devConfig.getRecapchaLogin()
                        ) {
                            $$('consultButton').define('disabled', true); // Disable button during processing
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for the request
                                })
                                .post(
                                    devConfig.geturlApi() + '/en/Account/Login',
                                    '{"Username":"' +
                                        items.username +
                                        '","Password":"' +
                                        items.password +
                                        '","PartnerLogin":"' +
                                        url +
                                        '","GrecaptchaResponse":"' +
                                        items['g-recaptcha-response'] +
                                        '"}',
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Show error message on failure
                                            if (data.messageUrl != undefined) {
                                                webix
                                                    .alert({
                                                        title: _('¡Atención!'),
                                                        text: _('Te estas logueando desde el sitio equivocado.'),
                                                        type: 'alert-warning',
                                                    })
                                                    .then(function (result) {});
                                            }
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var data = JSON.parse(text); // Parse response data
                                            if (!data.HasError) {
                                                if (data.ReqTokenGoogle) {
                                                    $$('formlog').hide(); // Hide login form
                                                    $$('formcode').show(); // Show code input form
                                                } else {
                                                    localStorage.setItem('x-token', data.Sess); // Store session token
                                                    devConfig.setCountries(data.Data.Countries); // Set countries data
                                                    devConfig.setProvidersCasino(data.Data.ProvidersCasino); // Set casino providers
                                                    devConfig.setSubProvidersCasino(data.Data.SubProvidersCasino); // Set sub-providers
                                                    devConfig.setGamesCasino(data.Data.GamesCasino); // Set games data
                                                    devConfig.setPerm(data.Data.PermissionList); // Set permissions
                                                    devConfig.setProfile(data.Data); // Set user profile data
                                                    superView.show('loading'); // Show loading view
                                                }
                                            } else {
                                                if (data.HasError) {
                                                    if (data.messageUrl != undefined) {
                                                        webix
                                                            .alert({
                                                                title: _('¡Atención!'),
                                                                ok: _('IR AL SITIO'),
                                                                text:
                                                                    _('Te estas logueando desde el sitio equivocado.') +
                                                                    '<br/><br/>' +
                                                                    _('¡Serás redireccionado a tu sitio!'),
                                                                type: 'alert-warning',
                                                            })
                                                            .then(function (result) {
                                                                superView.show(data.messageUrl); // Redirect to the specified URL
                                                            });
                                                    } else {
                                                        if (data.CodeError != undefined) {
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: _('ERROR' + data.CodeError.toString()),
                                                            });
                                                        } else {
                                                            if (
                                                                data.AlertMessage != undefined &&
                                                                data.AlertMessage != 'f'
                                                            ) {
                                                                webix.message({
                                                                    text: _(data.AlertMessage),
                                                                    type: 'error',
                                                                });
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                    },
                                )
                                .then((response) => {
                                    $$('consultButton').define('disabled', false); // Re-enable button after processing
                                })
                                .catch((e) => {
                                    $$('consultButton').define('disabled', false); // Re-enable button on error
                                });
                        } else {
                            webix.message({
                                text: _('Valide recapcha'), // Prompt to validate reCAPTCHA
                                title: '¡Error!',
                                type: 'alert-error',
                            });
                        }
                    } else {
                        webix.message({
                            text: _('Complete Datos'), // Prompt to complete data
                            title: '¡Error!',
                            type: 'alert-error',
                        });
                    }
                },
            },
        ];

        // Define the second form for Google token input
        const form2 = [
            {
                type: 'wide',
                css: 'close-bottom',
                id: 'close-buttom',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        bottom: 20,
                        right: 35,
                        width: 30,
                        height: 30,
                        click: () => {
                            $$('formlog').clear(); // Clear login form
                            $$('formcode').clear(); // Clear code form
                            $$('formlog').show(); // Show login form
                            $$('formcode').hide(); // Hide code form
                        },
                    },
                ],
            },
            {
                view: 'button',
                id: 'logo-login',
                css: 'logo-login',
                height: 60,
                align: 'center',
            },
            {
                view: 'label',
                label: 'Token Google',
                height: 25,
                css: 'login-username google-token',
            },
            {
                view: 'text',
                placeholder: 'Token',
                align: 'center',
                name: 'code',
                height: 38,
                marginY: 0,
            },
            {
                view: 'button',
                css: 'button-login',
                label: 'Continue', // Label for continue button
                hotkey: 'enter', // Hotkey for the button
                align: 'center',
                height: 38,
                click: () => {
                    var items = $$('formlog').getValues(); // Get values from the login form
                    var items2 = $$('formcode').getValues(); // Get values from the code form
                    const superView = this; // Reference to the current view
                    console.log(items2); // Log the token input values
                    var url2 = window.location.href.split('/'); // Split URL to analyze segments
                    var url = url2[4]; // Get the relevant segment for partner login
                    // Map partner names to corresponding IDs
                    if (url == 'virtualsoft') {
                        url = -1;
                    } else {
                        if (url == 'doradobet') {
                            url = 0;
                        } else {
                            if (url == 'justbet') {
                                url = 2;
                            } else {
                                if (url == 'ibetsupreme') {
                                    url = 1;
                                } else {
                                    if (url == 'miravalle') {
                                        url = 3;
                                    } else {
                                        if (url == 'casinopalace') {
                                            url = 4;
                                        } else {
                                            if (url == 'netabet') {
                                                url = 6;
                                            } else {
                                                if (url == 'intercontinental') {
                                                    url = 5;
                                                } else {
                                                    if (url == 'astonia') {
                                                        url = 7;
                                                    } else {
                                                        if (url == 'ecuabet') {
                                                            url = 8;
                                                        } else {
                                                            if (url == 'winbet') {
                                                                url = 9;
                                                            } else {
                                                                if (url == 'powerbet') {
                                                                    url = 12;
                                                                } else {
                                                                    if (url == 'tribet') {
                                                                        url = 13;
                                                                    } else {
                                                                        if (url == 'lotosports') {
                                                                            url = 14;
                                                                        } else {
                                                                            if (url == 'hondubet') {
                                                                                url = 15;
                                                                            } else {
                                                                                if (url == 'latinbet') {
                                                                                    url = 16;
                                                                                } else {
                                                                                    if (url == 'milbets') {
                                                                                        url = 17;
                                                                                    } else {
                                                                                        if (url == 'gangabet') {
                                                                                            url = 18;
                                                                                        } else {
                                                                                            if (
                                                                                                url == 'certdoradobet'
                                                                                            ) {
                                                                                                url = 10;
                                                                                            } else {
                                                                                                if (url == 'sivarbet') {
                                                                                                    url = 20;
                                                                                                } else {
                                                                                                    if (url == 'vsft') {
                                                                                                        url = 19;
                                                                                                    } else {
                                                                                                        if (
                                                                                                            url ==
                                                                                                            'camanbet'
                                                                                                        ) {
                                                                                                            url = 21;
                                                                                                        } else {
                                                                                                            if (
                                                                                                                url ==
                                                                                                                'ganamex'
                                                                                                            ) {
                                                                                                                url = 22;
                                                                                                            } else {
                                                                                                                if (
                                                                                                                    url ==
                                                                                                                    'paniplay'
                                                                                                                ) {
                                                                                                                    url = 23;
                                                                                                                } else {
                                                                                                                    if (
                                                                                                                        url ==
                                                                                                                        'redcasino'
                                                                                                                    ) {
                                                                                                                        url = 25;
                                                                                                                    } else {
                                                                                                                        if (
                                                                                                                            url ==
                                                                                                                            'ganaplay'
                                                                                                                        ) {
                                                                                                                            url = 27;
                                                                                                                        } else {
                                                                                                                            if (
                                                                                                                                url ==
                                                                                                                                'slotdunyasi'
                                                                                                                            ) {
                                                                                                                                url = 28;
                                                                                                                            } else {
                                                                                                                                if (
                                                                                                                                    url ==
                                                                                                                                    'rapidplay'
                                                                                                                                ) {
                                                                                                                                    url = 29;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // Validate token input
                    if (items2.code !== '') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + '/en/Account/LoginGoogle',
                                '{"Username":"' +
                                    items.username +
                                    '","Password":"' +
                                    items.password +
                                    '","Code":"' +
                                    items2.code +
                                    '", "PartnerLogin":"' +
                                    url +
                                    '"}',
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Show error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var data = JSON.parse(text); // Parse response data
                                        if (!data.HasError) {
                                            localStorage.setItem('x-token', data.Sess); // Store session token
                                            devConfig.setCountries(data.Data.Countries); // Set countries data
                                            devConfig.setProvidersCasino(data.Data.ProvidersCasino); // Set casino providers
                                            devConfig.setSubProvidersCasino(data.Data.SubProvidersCasino); // Set sub-providers
                                            devConfig.setGamesCasino(data.Data.GamesCasino); // Set games data
                                            devConfig.setPerm(data.Data.PermissionList); // Set permissions
                                            devConfig.setProfile(data.Data); // Set user profile data
                                            superView.show('loading'); // Show loading view
                                        } else {
                                            if (data.HasError) {
                                                if (data.CodeError != undefined) {
                                                    webix.alert({
                                                        title: '¡Error!',
                                                        text: _('ERROR' + data.CodeError.toString()),
                                                        type: 'alert-error',
                                                    });
                                                } else {
                                                    if (data.AlertMessage != undefined && data.AlertMessage != 'f') {
                                                        webix.alert({
                                                            title: '¡Error!',
                                                            text: data.AlertMessage,
                                                            type: 'alert-error',
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            text: 'Código Requerido', // Prompt for required code
                            title: '¡Error!',
                            type: 'alert-error',
                        });
                    }
                },
            },
        ];

        // Define the third form for email recovery
        const form3 = [
            {
                type: 'wide',
                css: 'close-bottom',
                id: 'close-buttom',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        bottom: 20,
                        right: 35,
                        width: 30,
                        height: 30,
                        click: () => {
                            $$('formlog').clear(); // Clear login form
                            $$('formemail').clear(); // Clear email form
                            $$('formlog').show(); // Show login form
                            $$('formemail').hide(); // Hide email form
                        },
                    },
                ],
            },
            {
                view: 'button',
                id: 'logo-login',
                css: 'logo-login',
                height: 60,
                align: 'center',
            },
            {
                view: 'label',
                label: 'Email',
                height: 25,
                css: 'login-username reset-email',
            },
            {
                view: 'text',
                placeholder: 'Email',
                align: 'center',
                name: 'Email',
                height: 38,
                marginY: 0,
                required: true, // Email field is required
            },
            {
                view: 'button',
                css: 'button-login',
                label: 'Continue', // Label for continue button
                hotkey: 'enter', // Hotkey for the button
                align: 'center',
                height: 38,
                click: () => {
                    var items = $$('formemail').getValues(); // Get values from the email form
                    var url2 = window.location.href.split('/'); // Split URL to analyze segments
                    var url = url2[4]; // Get the relevant segment for partner login
                    // Map partner names to corresponding IDs
                    if (url == 'virtualsoft') {
                        url = -1;
                    } else {
                        if (url == 'doradobet') {
                            url = 0;
                        } else {
                            if (url == 'justbet') {
                                url = 2;
                            } else {
                                if (url == 'ibetsupreme') {
                                    url = 1;
                                } else {
                                    if (url == 'miravalle') {
                                        url = 3;
                                    } else {
                                        if (url == 'casinopalace') {
                                            url = 4;
                                        } else {
                                            if (url == 'netabet') {
                                                url = 6;
                                            } else {
                                                if (url == 'intercontinental') {
                                                    url = 5;
                                                } else {
                                                    if (url == 'astonia') {
                                                        url = 7;
                                                    } else {
                                                        if (url == 'ecuabet') {
                                                            url = 8;
                                                        } else {
                                                            if (url == 'winbet') {
                                                                url = 9;
                                                            } else {
                                                                if (url == 'powerbet') {
                                                                    url = 12;
                                                                } else {
                                                                    if (url == 'tribet') {
                                                                        url = 13;
                                                                    } else {
                                                                        if (url == 'lotosports') {
                                                                            url = 14;
                                                                        } else {
                                                                            if (url == 'hondubet') {
                                                                                url = 15;
                                                                            } else {
                                                                                if (url == 'latinbet') {
                                                                                    url = 16;
                                                                                } else {
                                                                                    if (url == 'milbets') {
                                                                                        url = 17;
                                                                                    } else {
                                                                                        if (url == 'gangabet') {
                                                                                            url = 18;
                                                                                        } else {
                                                                                            if (
                                                                                                url == 'certdoradobet'
                                                                                            ) {
                                                                                                url = 10;
                                                                                            } else {
                                                                                                if (url == 'sivarbet') {
                                                                                                    url = 20;
                                                                                                } else {
                                                                                                    if (url == 'vsft') {
                                                                                                        url = 19;
                                                                                                    } else {
                                                                                                        if (
                                                                                                            url ==
                                                                                                            'camanbet'
                                                                                                        ) {
                                                                                                            url = 21;
                                                                                                        } else {
                                                                                                            if (
                                                                                                                url ==
                                                                                                                'ganamex'
                                                                                                            ) {
                                                                                                                url = 22;
                                                                                                            } else {
                                                                                                                if (
                                                                                                                    url ==
                                                                                                                    'paniplay'
                                                                                                                ) {
                                                                                                                    url = 23;
                                                                                                                } else {
                                                                                                                    if (
                                                                                                                        url ==
                                                                                                                        'redcasino'
                                                                                                                    ) {
                                                                                                                        url = 25;
                                                                                                                    } else {
                                                                                                                        if (
                                                                                                                            url ==
                                                                                                                            'ganaplay'
                                                                                                                        ) {
                                                                                                                            url = 27;
                                                                                                                        } else {
                                                                                                                            if (
                                                                                                                                url ==
                                                                                                                                'slotdunyasi'
                                                                                                                            ) {
                                                                                                                                url = 28;
                                                                                                                            } else {
                                                                                                                                if (
                                                                                                                                    url ==
                                                                                                                                    'rapidplay'
                                                                                                                                ) {
                                                                                                                                    url = 29;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // Validate email input
                    if ($$('formemail').validate()) {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + '/en/Account/ResetPassword',
                                '{"Email":"' + items.Email + '","Partnert":"' + url + '"}',
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Show error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var data = JSON.parse(text); // Parse response data
                                        if (!data.HasError) {
                                            webix.message(
                                                _(
                                                    'Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.',
                                                ),
                                            ); // Show success message
                                            $$('formlog').clear(); // Clear login form
                                            $$('formemail').clear(); // Clear email form
                                            $$('formlog').show(); // Show login form
                                            $$('formemail').hide(); // Hide email form
                                        } else {
                                            if (data.HasError) {
                                                if (data.CodeError != undefined) {
                                                    webix.alert({
                                                        title: '¡Error!',
                                                        text: _('ERROR' + data.CodeError.toString()),
                                                        type: 'alert-error',
                                                    });
                                                } else {
                                                    if (data.AlertMessage != undefined && data.AlertMessage != 'f') {
                                                        webix.alert({
                                                            title: '¡Error!',
                                                            text: data.AlertMessage,
                                                            type: 'alert-error',
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            text: _('Email Inválido'), // Prompt for invalid email
                            title: '¡Error!',
                            type: 'alert-error',
                        });
                    }
                },
            },
        ];

        // Define the fourth form for password reset
        const form4 = [
            {
                type: 'wide',
                css: 'close-bottom',
                id: 'close-buttom',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        bottom: 20,
                        right: 35,
                        width: 30,
                        height: 30,
                        click: () => {
                            $$('formlog').clear(); // Clear login form
                            $$('formpassword').clear(); // Clear password form
                            $$('formlog').show(); // Show login form
                            $$('formpassword').hide(); // Hide password form
                        },
                    },
                ],
            },
            {
                view: 'button',
                id: 'logo-login',
                css: 'logo-login',
                height: 60,
                align: 'center',
            },
            {
                view: 'label',
                label: _('Nueva Contraseña'),
                height: 20,
                css: 'login-password',
            },
            {
                view: 'text',
                placeholder: _('Nueva Contraseña'),
                height: 38,
                marginY: 0,
                align: 'center',
                name: 'NewPassword',
                id: 'NewPassword',
                invalidMessage: _('Mínimo 8 caracteres, una minúscula, una mayúscula y un número.'),
                validate: function (value) {
                    return value.length >= 8 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value); // Validate password strength
                },
                on: {
                    onBlur: function () {
                        $$('NewPassword').validate(); // Validate on blur
                    },
                },
            },
            {
                view: 'label',
                label: _('Confirmar Contraseña'),
                height: 20,
                css: 'login-password',
            },
            {
                view: 'text',
                placeholder: _('Confirmar Contraseña'),
                height: 38,
                marginY: 0,
                align: 'center',
                name: 'ConfirmPassword',
                id: 'ConfirmPassword',
                invalidMessage: _('Contraseñas no coinciden'),
                validate: function (value) {
                    return value == $$('NewPassword').getValue(); // Validate password confirmation
                },
                on: {
                    onBlur: function () {
                        $$('ConfirmPassword').validate(); // Validate on blur
                    },
                },
            },
            {
                view: 'button',
                css: 'button-login',
                label: 'Continue', // Label for continue button
                hotkey: 'enter', // Hotkey for the button
                align: 'center',
                height: 38,
                click: () => {
                    var items = $$('formpassword').getValues(); // Get values from the password form
                    // Validate new password and confirmation
                    if (items.NewPassword !== '' && items.ConfirmPassword !== '') {
                        if (items.NewPassword == items.ConfirmPassword) {
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type for the request
                                })
                                .post(
                                    devConfig.geturlApi() + '/en/Account/ResetPasswordToken',
                                    '{"NewPassword":"' + items.NewPassword + '","ResetCode":"' + codeReset + '"}',
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Show error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var data = JSON.parse(text); // Parse response data
                                            if (!data.HasError) {
                                                webix.message(_('Contraseña cambiada satisfactoriamente.')); // Show success message
                                                $$('formlog').clear(); // Clear login form
                                                $$('formpassword').clear(); // Clear password form
                                                $$('formlog').show(); // Show login form
                                                $$('formpassword').hide(); // Hide password form
                                            } else {
                                                if (data.HasError) {
                                                    if (data.CodeError != undefined) {
                                                        webix.alert({
                                                            title: '¡Error!',
                                                            text: _('ERROR' + data.CodeError.toString()),
                                                            type: 'alert-error',
                                                        });
                                                    } else {
                                                        if (
                                                            data.AlertMessage != undefined &&
                                                            data.AlertMessage != 'f'
                                                        ) {
                                                            webix.alert({
                                                                title: '¡Error!',
                                                                text: data.AlertMessage,
                                                                type: 'alert-error',
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                    },
                                );
                        } else {
                            webix.message({
                                text: _('Nueva contraseña y confirmar contraseña no coinciden.'), // Prompt for password mismatch
                                title: '¡Error!',
                                type: 'alert-error',
                            });
                        }
                    } else {
                        webix.message({
                            text: _('Completa los campos...'), // Prompt to complete fields
                            title: '¡Error!',
                            type: 'alert-error',
                        });
                    }
                },
            },
        ];

        // --- Inject inline CSS for the password eye inside input ---
        (function(){
            var css = ""
                + ".password-eye{ position:absolute; right:12px; top:50%; transform:translateY(-50%); cursor:pointer; z-index:2; }"
                + "#passwordField .webix_inp_static{ position:relative; }";
            var styleEl = document.createElement('style');
            styleEl.type = 'text/css';
            styleEl.appendChild(document.createTextNode(css));
            document.head.appendChild(styleEl);
        })();

        // Set up the main layout for the login view
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            margin: 20,
            type: 'space',
            view: 'form',
            css: 'background-login', // CSS class for background styling
            scroll: 'y',
            cols: [
                {},
                {
                    scroll: 'y',
                    rows: [
                        {},
                        {
                            css: 'login',
                            paddingX: 40,
                            view: 'form',
                            width: devConfig.getRecapchaLogin() ? 390 : 300, // Adjust width based on reCAPTCHA setting
                            height: devConfig.getRecapchaLogin() ? 380 : 320, // Adjust height based on reCAPTCHA setting
                            id: 'formlog', // ID for the login form
                            elements: form1, // Elements for the login form
                            scroll: false,
                        },
                        {
                            css: 'login',
                            paddingX: 40,
                            view: 'form',
                            width: 300,
                            height: 320,
                            id: 'formcode', // ID for the code input form
                            elements: form2, // Elements for the code input form
                            scroll: false,
                        },
                        {
                            css: 'login',
                            paddingX: 40,
                            view: 'form',
                            width: screen.width < 500 ? 300 : 400, // Adjust width based on screen size
                            height: 300,
                            id: 'formemail', // ID for the email recovery form
                            elements: form3, // Elements for the email recovery form
                            scroll: false,
                            rules: {
                                Email: webix.rules.isEmail, // Validation rule for email
                            },
                            elementsConfig: {
                                on: {
                                    onChange: function (newv, oldv) {
                                        this.validate(); // Validate on change
                                    },
                                },
                            },
                        },
                        {
                            css: 'login',
                            paddingX: 40,
                            view: 'form',
                            width: screen.width < 500 ? 300 : 450, // Adjust width based on screen size
                            height: 370,
                            id: 'formpassword', // ID for the password reset form
                            elements: form4, // Elements for the password reset form
                            scroll: false,
                        },
                        {},
                    ],
                },
                {},
            ],
        };
    }

    /**
     * Initializes the login view and sets up event listeners.
     */
    init() {
        const superView = this; // Reference to the current view
        var url = window.location.href.split('/'); // Split URL to analyze segments
        var body = document.body; // Reference to the document body
        // Set background image based on partner name in the URL
        if (url[4] == 'virtualsoft') {
            body.style.setProperty('--bg-image', 'url(/sources/assets/plugins/images/logo-virtualsoft.svg)');
        } else {
            if (url[4] == 'doradobet') {
                body.style.setProperty('--bg-image', 'url(/sources/assets/plugins/images/logo-dorado.svg)');
            } else {
                if (url[4] == 'justbet') {
                    body.style.setProperty('--bg-image', 'url(/sources/assets/plugins/images/logo-justbet.svg)');
                } else {
                    if (url[4] == 'ibetsupreme') {
                        body.style.setProperty('--bg-image', 'url(/sources/assets/plugins/images/logo-guyana.svg)');
                    } else {
                        if (url[4] == 'miravalle') {
                            body.style.setProperty(
                                '--bg-image',
                                'url(/sources/assets/plugins/images/logo-justbet.svg)',
                            );
                        } else {
                            if (url[4] == 'casinopalace') {
                                body.style.setProperty(
                                    '--bg-image',
                                    'url(/sources/assets/plugins/images/logo-casinopalace.svg)',
                                );
                            } else {
                                if (url[4] == 'netabet') {
                                    body.style.setProperty(
                                        '--bg-image',
                                        'url(/sources/assets/plugins/images/logo-netabet.svg)',
                                    );
                                } else {
                                    if (url[4] == 'intercontinental') {
                                        body.style.setProperty(
                                            '--bg-image',
                                            'url(/sources/assets/plugins/images/logo-intercontinental.svg)',
                                        );
                                    } else {
                                        if (url[4] == 'astonia') {
                                            body.style.setProperty(
                                                '--bg-image',
                                                'url(/sources/assets/plugins/images/logo-astonia.svg)',
                                            );
                                        } else {
                                            if (url[4] == 'ecuabet') {
                                                body.style.setProperty(
                                                    '--bg-image',
                                                    'url(/sources/assets/plugins/images/logo-ecuabet.svg)',
                                                );
                                            } else {
                                                if (url[4] == 'winbet') {
                                                    body.style.setProperty(
                                                        '--bg-image',
                                                        'url(/sources/assets/plugins/images/logo-winbet.svg)',
                                                    );
                                                } else {
                                                    if (url[4] == 'powerbet') {
                                                        body.style.setProperty(
                                                            '--bg-image',
                                                            'url(https://images.virtualsoft.tech/m/msjT1683045925.png)',
                                                        );
                                                    } else {
                                                        if (url[4] == 'tribet') {
                                                            body.style.setProperty(
                                                                '--bg-image',
                                                                'url(/sources/assets/plugins/images/logo-tribet.svg)',
                                                            );
                                                        } else {
                                                            if (url[4] == 'lotosports') {
                                                                body.style.setProperty(
                                                                    '--bg-image',
                                                                    'url(/sources/assets/plugins/images/logo-lotosports.svg)',
                                                                );
                                                            } else {
                                                                if (url[4] == 'hondubet') {
                                                                    body.style.setProperty(
                                                                        '--bg-image',
                                                                        'url(/sources/assets/plugins/images/logo-hondubet.svg)',
                                                                    );
                                                                } else {
                                                                    if (url[4] == 'latinbet') {
                                                                        body.style.setProperty(
                                                                            '--bg-image',
                                                                            'url(/sources/assets/plugins/images/logo-latinbet.svg)',
                                                                        );
                                                                    } else {
                                                                        if (url[4] == 'milbets') {
                                                                            body.style.setProperty(
                                                                                '--bg-image',
                                                                                'url(/sources/assets/plugins/images/logo-milbets.svg)',
                                                                            );
                                                                        } else {
                                                                            if (url[4] == 'gangabet') {
                                                                                body.style.setProperty(
                                                                                    '--bg-image',
                                                                                    'url(/sources/assets/plugins/images/logo-gangabet.svg)',
                                                                                );
                                                                            } else {
                                                                                if (url[4] == 'certdoradobet') {
                                                                                    body.style.setProperty(
                                                                                        '--bg-image',
                                                                                        'url(/sources/assets/plugins/images/logo-dorado.svg)',
                                                                                    );
                                                                                } else {
                                                                                    if (url[4] == 'vsft') {
                                                                                        body.style.setProperty(
                                                                                            '--bg-image',
                                                                                            'url(/sources/assets/plugins/images/logo-dorado.svg)',
                                                                                        );
                                                                                    } else {
                                                                                        if (url[4] == 'ganamex') {
                                                                                            body.style.setProperty(
                                                                                                '--bg-image',
                                                                                                'url(https://images.virtualsoft.tech/m/msjT1695833918.png)',
                                                                                            );
                                                                                        } else {
                                                                                            if (url[4] == 'camanbet') {
                                                                                                body.style.setProperty(
                                                                                                    '--bg-image',
                                                                                                    'url(https://images.virtualsoft.tech/m/msjT1695228079.png)',
                                                                                                );
                                                                                            } else {
                                                                                                if (
                                                                                                    url[4] == 'paniplay'
                                                                                                ) {
                                                                                                    body.style.setProperty(
                                                                                                        '--bg-image',
                                                                                                        'url(https://images.virtualsoft.tech/m/msj212T1703103288.png)',
                                                                                                    );
                                                                                                } else {
                                                                                                    if (
                                                                                                        url[4] ==
                                                                                                        'redcasino'
                                                                                                    ) {
                                                                                                        body.style.setProperty(
                                                                                                            '--bg-image',
                                                                                                            'url(https://images.virtualsoft.tech/m/msj0212T1712066153.png)',
                                                                                                        );
                                                                                                    } else {
                                                                                                        if (
                                                                                                            url[4] ==
                                                                                                            'ganaplay'
                                                                                                        ) {
                                                                                                            body.style.setProperty(
                                                                                                                '--bg-image',
                                                                                                                'url(https://images.virtualsoft.tech/m/msj0212T1747667964.png)',
                                                                                                            );
                                                                                                        } else {
                                                                                                            if (
                                                                                                                url[4] ==
                                                                                                                'slotdunyasi'
                                                                                                            ) {
                                                                                                                body.style.setProperty(
                                                                                                                    '--bg-image',
                                                                                                                    'url(https://images.virtualsoft.tech/m/msj19212T1752178285.png)',
                                                                                                                );
                                                                                                            } else {
                                                                                                                if (
                                                                                                                    url[4] ==
                                                                                                                    'rapidplay'
                                                                                                                ) {
                                                                                                                    body.style.setProperty(
                                                                                                                        '--bg-image',
                                                                                                                        'url(https://images.virtualsoft.tech/m/msj0212T1753906591.png)',
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        var subdomain = window.location.host.split('.')[1]; // Get subdomain from host
        if (subdomain !== undefined) {
            if (subdomain !== 'virtualsoft') {
                if (subdomain == 'justbetja') {
                    if ('justbet' !== url[4]) {
                        superView.show('/justbet'); // Redirect to justbet if not already on that page
                    }
                } else {
                    if (subdomain == 'ibetgamesgy') {
                        if ('ibetsupreme' !== url[4]) {
                            superView.show('/ibetsupreme'); // Redirect to ibetsupreme if not already on that page
                        }
                    } else {
                        if (subdomain == 'casinogranpalaciomx') {
                            if ('casinopalace' !== url[4]) {
                                superView.show('/casinopalace'); // Redirect to casinopalace if not already on that page
                            }
                        } else {
                            if (subdomain == 'casinomiravallepalace') {
                                if ('miravalle' !== url[4]) {
                                    superView.show('/miravalle'); // Redirect to miravalle if not already on that page
                                }
                            } else {
                                if (subdomain == 'casinoastoriamx') {
                                    if ('astonia' !== url[4]) {
                                        superView.show('/astonia'); // Redirect to astonia if not already on that page
                                    }
                                } else {
                                    if (subdomain == 'casinointercontinentalmx') {
                                        if ('intercontinental' !== url[4]) {
                                            superView.show('/intercontinental'); // Redirect to intercontinental if not already on that page
                                        }
                                    } else {
                                        if (subdomain == 'eltribet') {
                                            if ('tribet' !== url[4]) {
                                                superView.show('/tribet'); // Redirect to tribet if not already on that page
                                            }
                                        } else {
                                            if (subdomain == 'lotosports') {
                                                if ('lotosports' !== url[4]) {
                                                    superView.show('/lotosports'); // Redirect to lotosports if not already on that page
                                                }
                                            } else {
                                                if (subdomain !== url[4]) {
                                                    try {
                                                        superView.show('/' + subdomain); // Redirect to the subdomain if not already on that page
                                                    } catch (e) {
                                                        superView.show('/virtualsoft'); // Fallback to virtualsoft on error
                                                        console.log(e); // Log any errors
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        // Reload the page on hash change for specific URLs
        $(window).on('hashchange', function (e) {
            if (
                url[4] == 'virtualsoft' ||
                url[4] == 'doradobet' ||
                url[4] == 'justbet' ||
                url[4] == 'ibetsupreme' ||
                url[4] == 'miravalle' ||
                url[4] == 'ecuabet' ||
                url[4] == 'netabet' ||
                url[4] == 'winbet' ||
                url[4] == 'hondubet' ||
                url[4] == 'latinbet' ||
                url[4] == 'milbets' ||
                url[4] == 'gangabet' ||
                url[4] == 'certdoradobet' ||
                url[4] == 'sivarbet' ||
                url[4] == 'vsft' ||
                url[4] == 'ganamex' ||
                url[4] == 'camanbet' ||
                url[4] == 'paniplay' ||
                url[4] == 'redcasino' ||
                url[4] == 'ganaplay' ||
                url[4] == 'slotdunyasi' ||
                url[4] == 'rapidplay'
            ) {
                location.reload(); // Reload the page on hash change
            }
        });
        $$('formcode').hide(); // Initially hide the code input form
        $$('formemail').hide(); // Initially hide the email recovery form
        $$('formpassword').hide(); // Initially hide the password reset form
        if ($$('pagerr')) {
            $$('pagerr').hide(); // Hide page error element if it exists
        }
        webix.ready(function () {
            url.forEach(function (obj) {
                if (obj == 'reset-password') {
                    $$('formlog').hide(); // Hide login form if reset-password is in the URL
                    $$('formpassword').show(); // Show password reset form
                    superView.app.callEvent('codeReset', [{}]); // Trigger code reset event
                }
            });
        });
    }
}

// FILE DOCUMENTED
